import { SelectChangeEvent } from '@mui/material';
import { useState, useEffect } from 'react';
import { Target } from 'generated/maya.types';

const useMiViewAccountSelector = (
  accounts: Target[] | [],
  setSelectedAccount: Function,
) => {
  const [filteredAccounts, setFilteredAccounts] = useState<Target[]>([]);

  useEffect(() => {
    const filteredItems = accounts
      ?.filter((account) => account.firstName && account.lastName)
      ?.sort((a, b) => (a.lastName ?? '').localeCompare(b.lastName ?? ''));

    setFilteredAccounts(filteredItems);
  }, [accounts]);

  const handleChange = (event: SelectChangeEvent) => {
    setSelectedAccount(accounts?.find((account: Target) => account?.mdmId === event.target.value));
  };

  return {
    handleChange,
    filteredAccounts,
  };
};

export default useMiViewAccountSelector;
